import {
    makeHttpRequest,
    mapDatabaseParamsFromServer,
    mapPaginationParamsToServer,
} from "@/shared";

import { mapShiftRowsFromServer } from "./mappers/mapShiftRowsFromServer";

export const getShifts = async (params) => {
    const response = (
        await makeHttpRequest({
            url: "/human/shifts",
            method: "GET",
            params: mapPaginationParamsToServer(params),
        })
    ).data;

    return {
        data: mapShiftRowsFromServer(response.data),
        ...mapDatabaseParamsFromServer(response),
    };
};
